// extracted by mini-css-extract-plugin
module.exports = {"container":"diji-blog-text-caption_container__skGQ7","textCaption":"diji-blog-text-caption_textCaption__6l1v6"};